export default "__VITE_ASSET__b81ffe35__"